import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";

const EventPage = () => {
  const [events, setEvents] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    fetch("https://kasiaweb.ilakshyaerp.in/api/events")
      .then((res) => res.json())
      .then((data) => setEvents(Array.isArray(data) ? data : []))
      .catch((err) => console.log("Event fetch error:", err));
  }, []);

  return (
    <>
      <Header toggleSidebar={() => setOpen(true)} />

      <Sidebar isOpen={open} close={() => setOpen(false)} />

      {/* HERO */}
      <div className="about-hero">
        <div className="about-overlay">
          <h1>EVENTS</h1>
          <p>Celebrating excellence and achievements</p>
          <Breadcrumb />
        </div>
      </div>

      <div className="gallery-section">
        <h2 className="gallery-title">SCHOOL EVENTS</h2>
      </div>

      <div className="container">

        <div className="events-grid">
          {events.length > 0 ? (
            events.map((e) => (
              <div className="event-card" key={e.id}>
                <img
                  src={`https://kasiaweb.ilakshyaerp.in/uploads/events/${e.image}`}
                  alt="event"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setSelectedImage(
                      `https://kasiaweb.ilakshyaerp.in/uploads/events/${e.image}`
                    )
                  }
                />
                <p>{e.narration}</p>
              </div>
            ))
          ) : (
            <p className="life-empty">
              No news available
            </p>
          )}
        </div>
      </div>

      {selectedImage && (
        <div
          className="event-modal"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="event-close"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedImage(null);
            }}
          >
            ✕
          </button>

          <img
            src={selectedImage}
            alt=""
            className="event-full-image"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      <Footer />
    </>
  );
};

export default EventPage;